// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"1b4b0aaa","329":"4a5f5070","373":"9d2ca3e6","427":"1e5faaeb","442":"d9fd9e95","453":"727e2aab","455":"9d208870","488":"3888fb08","497":"a653be85","571":"e0b51a52","770":"8828c235","771":"8ab78aff","881":"c8e858e1","886":"f4bed273"}[chunkId] + ".chunk.js";
};